import { APP_NAME } from '@/src/static';
import { useEffect } from 'react';

export function setDocTitle(title: string): void {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    document.title = `${APP_NAME} - ${title}`;
  }, [title]);
}
